import { Outlet } from "react-router-dom"

const MainChat = () =>{

    return(
        <div className=" w-full h-full">
         <Outlet/>
        </div>
    )
}


export default MainChat;